import { render } from "./parametrizacionley.vue?vue&type=template&id=a13a1184"
import script from "./parametrizacionley.vue?vue&type=script&lang=js"
export * from "./parametrizacionley.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__